export const formFieldNames = <const>{
    name: 'name',
};

export const nameMaxLength = 100;
